/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { Suspense, useEffect, useRef } from "react";

import * as React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Provider as ReduxProvider } from "react-redux";
import store from "reducers/Store";
import { AppRouter } from "components/AppRouter";
import { HoverAnimationProvider } from "components/shared/HoverAnimation";
import WebGPUSurvey from "./WebGPUSurvey";
import PurchaseExpressQueryParam from "./PurchaseExpressQueryParam";
import AppLoading from "components/AppLoading";
import { DebugPanel } from "components/DebugPanel";

const AppRoot = (): React.ReactElement => {
  return (
    <Suspense fallback={<AppLoading />}>
      <ReduxProvider store={store}>
        <DndProvider backend={HTML5Backend}>
          <HoverAnimationProvider>
            <DebugPanel />
            <AppRouter />
            <WebGPUSurvey />
            <PurchaseExpressQueryParam />
          </HoverAnimationProvider>
        </DndProvider>
      </ReduxProvider>
    </Suspense>
  );
};

export default AppRoot;
